export default __webpack_public_path__ + "sounds/endingMusic.mp3";